import React from 'react';
import { Box, Typography } from '@mui/material';

interface ModuleDisplayProps {
    height: number | string;
    moduleName: string;
}

const NoDataFound: React.FC<ModuleDisplayProps> = ({ height, moduleName }) => {

    return (
        <Box sx={{ height: height, p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 3, }} >
            <Box sx={{ textAlign: 'center', }} >
                <Box
                    component="img"
                    src="/images/no-data.gif"
                    alt="No Data"
                    sx={{
                        width: 200, height: 200, mb: 2, borderRadius: '50%', objectFit: 'cover',
                    }}
                />
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 'bold',
                        color: 'text.primary',
                        mb: 1.5,
                        letterSpacing: 0.5,
                    }}
                >
                    No Data Available for {moduleName}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        mb: 3,
                    }}
                >
                    It looks like there's no data to display right now. Please try again later or contact our support team.
                </Typography>
            </Box>
        </Box>
    );
};

export default NoDataFound;
